<template>
	<div class="input textarea" :class="{ 'input-error': errors[id] }">
		<label :for="id" v-if="name">{{ name }}</label>
		<textarea :id="id" v-model="form[id]" @keyup="errors[id] = ''" :rows="5" :placeholder="placeholder"/>
		<span class="error-message">{{ errors[id] }}</span>
	</div>
</template>

<script>
	export default {
		props: ['id', 'name', 'form', 'errors', 'placeholder']
	}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Form/InputTextArea.vue